import Select, { components } from 'react-select'
import React from 'react'
import { useState } from 'react'
import { accountGroupService } from '../../service/AccountGroupService'
import {
  showErrorToast,
  showSuccessToast,
  toastKey,
} from '../../utils/showToast'
import { CiCirclePlus } from 'react-icons/ci'
const Option = (props) => {
  return (
    <components.Option {...props}>
      <div className="flex items-center justify-between">
        <span>{props.label}</span>
        {props.isSelected && <span className="text-[#000]">✔</span>}
      </div>
    </components.Option>
  )
}
const SelectInput = ({ defaultValue, data, setDataGroup, setData }) => {
  var options = data
    ? data.map((item) => ({
        label: item.name,
        value: item.uuid,
      }))
    : []
  const handleChange = (value) => {
    const selectedValues = value ? value.map((item) => item.value) : []
    setDataGroup(selectedValues)
  }
  const [newOption, setNewOptions] = useState(null)
  const handleCreateOption = (inputValue) => {
    const exists = options.some((item) => item.label === inputValue)
    if (!exists) {
      setNewOptions(inputValue)
    }
  }
  const handleAddGroup = async (payload) => {
    try {
      const res = await accountGroupService.addGroup(payload)
      if (res?.meta?.code !== 201) {
        showErrorToast({
          message: res.message.content || 'Thêm nhóm thất bại',
          toastId: toastKey.ACCOUNT.GROUP.ADD,
        })
      }
      showSuccessToast('Thêm nhóm thành công', toastKey.ACCOUNT.GROUP.ADD)
      setData((prev) => [
        ...prev,
        {
          uuid: res?.message?.content?.uuid,
          name: res?.message?.content?.name,
          description: res?.message?.content?.description,
          createAt: res?.message.content?.createAt,
          createBy: res?.message.content?.createBy,
        },
      ])
      setDataGroup((prev) => [
        ...prev,
        {
          label: res?.data?.name,
          value: res?.data?.uuid,
        },
      ])
    } catch (error) {
      throw new Error(error.message || 'Lỗi không xác định!')
    }
  }
  const MenuList = (props) => {
    return (
      <components.MenuList {...props}>
        {props.children}
        <div className="mt-1 border-t border-gray-200 pt-2 text-start">
          <button
            onClick={() =>
              handleAddGroup({ name: newOption, description: newOption })
            }
            className="flex w-full items-center gap-1 rounded px-3 py-1 text-gray-500 hover:bg-gray-100"
          >
            <CiCirclePlus className="text-xl" />
            <span>Thêm nhóm mới</span>
          </button>
        </div>
      </components.MenuList>
    )
  }

  return (
    <div className="h-[100%] w-[80%]">
      <Select
        isMulti
        closeMenuOnSelect={false} // chọn nhiều mà menu không đóng
        hideSelectedOptions={false}
        defaultValue={
          defaultValue ? [{ label: defaultValue, value: defaultValue }] : []
        }
        options={options}
        onInputChange={handleCreateOption}
        components={{
          Option: Option,
          MenuList,
        }}
        placeholder="Chọn nhóm"
        styles={{
          option: (base) => ({
            ...base,
            backgroundColor: 'white',
            color: 'black',
            ':active': {
              ...base[':active'],
              backgroundColor: 'white',
            },
          }),
          control: (base) => ({
            ...base,
            minHeight: '48px',
            borderRadius: '0.375rem',
          }),
          menuList: (base) => ({
            ...base,
            maxHeight: 150, // ~ 2 item
            overflowY: 'auto',
          }),
        }}
        onChange={handleChange}
      />
    </div>
  )
}
export default SelectInput
